import { gsap } from "gsap";
import { disableScroll, enableScroll } from "./_helpers";

export default class Modal {
  constructor(modalContainer) {
    this.container = modalContainer;
    this.openButton = document.querySelector(".modal-toggler");
    this.widgetContainer = document.querySelector(".widget-container");
    // this.widgetHeight = this.widgetContainer.offsetHeight;
    this.tl = gsap.timeline();
    this.isModalOpen = false;

    this.initTimeLine();
    this.initListeners();

    // console.log(this.container.offsetHeight);

    // this.ro = new ResizeObserver((entries, observer) => {
    //   for (let entry of entries) {
    //     console.log(entry);
    //   }
    // });

    // this.ro.observe(this.widgetContainer, {
    //   box: "border-box",
    // });
  }

  initTimeLine = () => {
    this.tl.to(this.container, { height: "100vh", top: 0, yPercent: 0, duration: 0.4 }, "start");
    this.tl.to(this.widgetContainer, { scaleY: 1, duration: 0.4 }, "end");
    this.tl.pause();
  };

  handleModal = () => {
    if (this.isModalOpen) {
      gsap.set(this.widgetContainer, {
        // transformOrigin: "100% 100%",
      });

      this.tl.reverse();
      enableScroll();
    } else {
      gsap.set(this.widgetContainer, {
        // transformOrigin: "0 0",
      });

      this.tl.play();
      disableScroll();
    }

    this.changeModalStatus();
  };

  changeModalStatus = () => {
    this.isModalOpen = !this.isModalOpen;
  };

  initListeners = () => {
    this.openButton.addEventListener("click", this.handleModal);

    this.container.addEventListener("click", this.handleModal);
  };
}
